import styled from "styled-components";
import theme from "../../style/theme";
import ScheduleFirLineIcon from "../icons/ScheduleFirLineIcon/ScheduleFirLineIcon";

export const EmptyScheduleCollapse = () => {
  return (
    <EmptyScheduleContainer>
      <ScheduleFirLineIcon
        fill={`${theme.palette.primitives.gray400}`}
        width="48"
        height="48"
      />
      <EmptyScheduleTitle>등록 스케줄 없음</EmptyScheduleTitle>
      <EmptyScheduleBody>아직 등록된 오늘자</EmptyScheduleBody>
      <EmptyScheduleBody>스케줄이 없습니다</EmptyScheduleBody>
    </EmptyScheduleContainer>
  );
};

const EmptyScheduleContainer = styled.div`
  min-width: 118px;
  min-height: 124px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 25px;
`;
const EmptyScheduleTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: ${theme.palette.primitives.gray400};
  margin: 12px 0;
`;
const EmptyScheduleBody = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${theme.palette.primitives.gray400};
`;
